import { useSelector } from '@shared/store';

const DESKTOP_VIEWPORT_WIDTH_THRESHOLD = 840;

/*
    Exported so a component that already reads several slices of the store in one
    subscription can fold the desktop check into that selector rather than adding
    a second subscription. Worth doing wherever the component is rendered once
    per row of a long list — see the chat message container.
*/
export function selectIsDesktop(state: MBStoreState): boolean {
  return state.appState.viewportWidth >= DESKTOP_VIEWPORT_WIDTH_THRESHOLD;
}

// Note: these select the boolean rather than the raw width so a resize only
// re-renders subscribers when the breakpoint is actually crossed.
export function useIsDesktop() {
  return useSelector(selectIsDesktop);
}

export function useIsMobile() {
  return !useSelector(selectIsDesktop);
}
